






import { Vue, Prop, Watch, Component } from "vue-property-decorator";
import pc from './pc/curso.vue';
import movil from './movil/curso.vue';

@Component( {
    name: "Componente",
    props: {},
    components: { pc, movil }
} )
export default class Componente extends Vue
{
    created()
    {
        if ( this.$route.params.id == 'nuevo' )
            this.$EventBus.setTitulo( 'Nuevo curso' );
        else
            this.$EventBus.setTitulo( 'Editar curso' );
    }

}
